import { Description, Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { FunctionComponent, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  ButtonContainer,
  DoneButton,
  ErrorStyledContainer,
  ModalBackdrop,
  ModalContainer,
  StyledBigIcon,
  StyledDescription,
  StyledTitle,
} from "./styles";

import ErrorBall from "components/IconImage/errorBall";
import { configState, setLoader, setModal } from "state/config-slice";
import { AppDispatch } from "state/reducers-combiner";

const ErrorModal: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const currentConfig = useSelector(configState);
  const modal = currentConfig?.modal;
  const { title, description, customButtons, size } = modal;
  const closeModal = useCallback(() => dispatch(setModal({ showModal: false })), [dispatch]);

  useEffect(() => {
    dispatch(setLoader({ showLoader: false, messageHeader: "", messageText: "" }));
  }, [dispatch]);

  return (
    <Dialog open={modal.showModal} onClose={closeModal} as={ModalContainer} data-testid="error-modal">
      <ModalBackdrop data-testid="modal-backdrop" />

      <DialogPanel as={ErrorStyledContainer} type="error" size={size}>
        <StyledBigIcon>
          <ErrorBall />
        </StyledBigIcon>

        <DialogTitle as={StyledTitle}>{title ? t(title) : t("Oops! Technical error")}</DialogTitle>

        <Description as={StyledDescription}>
          {description ? t(description) : t("Please try again or reload the page")}
        </Description>

        <ButtonContainer>
          {customButtons ? customButtons : <DoneButton title={t("Done")} onClick={closeModal} />}
        </ButtonContainer>
      </DialogPanel>
    </Dialog>
  );
};

export default ErrorModal;
